import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import {
  getKnownSources,
  saveKnownSource,
  updateKnownSource,
  deleteKnownSource,
} from "../Apis/KnownSourceAPIs";
import { toast } from "react-toastify";
import { Modal, Button } from "react-bootstrap";

const KnownSourceLayer = () => {
  const [sources, setSources] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [editId, setEditId] = useState(null);

  // Modal State
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false);
  const [error, setError] = useState("");

  const fetchSources = async () => {
    setLoading(true);
    const res = await getKnownSources();
    if (res.status) {
      setSources(res.response?.data || res.response || []);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchSources();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!inputValue.trim()) {
      setError("Source Name is Required");
      return;
    }

    if (editId) {
      const res = await updateKnownSource(editId, { name: inputValue.trim() });
      if (res.status) {
        setInputValue("");
        setEditId(null);
        fetchSources();
      }
    } else {
      const res = await saveKnownSource({ name: inputValue.trim() });
      if (res.status) {
        toast.success("Source Added Successfully");
        setInputValue("");
        setError("");
        fetchSources();
      }
    }
  };

  const handleEdit = (item) => {
    setEditId(item._id || item.id);
    setInputValue(item.name || "");
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleDeleteClick = (item) => {
    setItemToDelete(item);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    if (!itemToDelete) return;
    setIsUpdating(true);
    const res = await deleteKnownSource(itemToDelete._id || itemToDelete.id);
    if (res.status) {
      toast.success("Source Deleted Successfully");
      fetchSources();
      setShowDeleteModal(false);
      setItemToDelete(null);
    }
    setIsUpdating(false);
  };

  return (
    <div className="card h-100 p-0 radius-12 overflow-hidden">
      <div
        className="card-header border-bottom py-16 px-24 d-flex align-items-center justify-content-between"
        style={{
          background:
            "linear-gradient(135deg, #000000 0%, #bb0007 50%, #ed1c24 100%)",
        }}
      >
        <h6 className="text-white mb-0">Source</h6>
      </div>
      <div className="card-body p-24">
        <form onSubmit={handleSubmit} className="row g-3 align-items-start mb-40">
          <div className="col-md-8">
            <label className="form-label fw-bold">
              Source Name <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className={`form-control radius-8 ${error ? "is-invalid" : ""}`}
              placeholder="e.g. Facebook & Instagram, Whatsapp, Newspaper"
              value={inputValue}
              onChange={(e) => {
                setInputValue(e.target.value);
                if (error) setError("");
              }}
            />
            {error && <div className="invalid-feedback">{error}</div>}
          </div>
          <div className="col-md-4">
            <button
              type="submit"
              className="btn radius-8 w-100 py-11 fw-bold mt-32 d-flex align-items-center justify-content-center gap-2"
              style={{ backgroundColor: "#f7e7da", color: "black", fontWeight: "600", border: "none" }}
            >
              {!editId && <Icon icon="ic:baseline-plus" className="text-xl" />}
              {editId ? "Update Source" : "Add Source"}
            </button>
          </div>
        </form>

        <div className="table-responsive scroll-sm">
          <table className="table bordered-table sm-table mb-0">
            <thead>
              <tr style={{ backgroundColor: "#f7e7da" }}>
                <th scope="col" style={{ color: "black", fontWeight: "bold", width: "80px" }}>
                  S.No
                </th>
                <th scope="col" style={{ color: "black", fontWeight: "bold" }}>
                  Source Name
                </th>
                <th
                  scope="col"
                  className="text-center"
                  style={{ color: "black", fontWeight: "bold", width: "120px" }}
                >
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="3" className="text-center py-24">
                    Loading...
                  </td>
                </tr>
              ) : sources.length === 0 ? (
                <tr>
                  <td colSpan="3" className="text-center py-24">
                    No sources found
                  </td>
                </tr>
              ) : (
                sources.map((item, index) => (
                  <tr key={item._id || item.id}>
                    <td>{index + 1}</td>
                    <td className="fw-semibold text-dark">{item.name}</td>
                    <td className="text-center">
                      <div className="d-flex align-items-center justify-content-center gap-2">
                        <button
                          onClick={() => handleEdit(item)}
                          className="btn-edit-custom fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                          title="Edit"
                        >
                          <Icon icon="lucide:edit" className="menu-icon" />
                        </button>
                        <button
                          onClick={() => handleDeleteClick(item)}
                          title="Delete"
                          className="bg-danger-focus text-danger-600 bg-hover-danger-200 w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle border-0"
                        >
                          <Icon icon="lucide:trash-2" className="text-xl" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        centered
      >
        <Modal.Body className="text-center p-5">
          <div className="d-flex justify-content-center mb-3">
            <div className="bg-danger-focus rounded-circle d-flex justify-content-center align-items-center w-64-px h-64-px">
              <Icon
                icon="solar:trash-bin-trash-bold"
                className="text-danger-600 text-xxl"
              />
            </div>
          </div>
          <h5 className="mb-2">Are you sure?</h5>
          <p className="text-secondary-light mb-4">
            Do you want to delete source "{itemToDelete?.name}"?
          </p>
          <div className="d-flex justify-content-center gap-3 mt-4">
            <Button
              variant="outline-secondary"
              className="px-32 radius-8"
              onClick={() => setShowDeleteModal(false)}
            >
              Cancel
            </Button>
            <Button
              className="px-32 radius-8 border-0"
              onClick={confirmDelete}
              disabled={isUpdating}
              style={{
                backgroundColor: "#ed1c24",
                color: "white",
              }}
            >
              {isUpdating ? "Deleting..." : "Confirm"}
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default KnownSourceLayer;
